const { createContext } = require('react');

const RecurringRuleConfigContext = createContext();
export default RecurringRuleConfigContext;
